export enum NotificationType {
  Ediary,
  Visit 
}
